import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1dc9cd37"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer-container" }
const _hoisted_2 = { class: "d-flex p-3 action-button-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["footer-content", { 'footer-background': !_ctx.hideBackground }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        (!_ctx.hideSkipButton)
          ? (_openBlock(), _createBlock(_component_AppButton, {
              key: 0,
              block: "",
              rounded: _ctx.rounded,
              variant: "gray-03",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('skip')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.skipButtonText), 1)
              ], undefined, true),
              _: 1
            }, 8, ["rounded"]))
          : _createCommentVNode("", true),
        _createTextVNode(),
        _createVNode(_component_AppButton, {
          block: "",
          rounded: _ctx.rounded,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('submit'))),
          disabled: _ctx.disabled,
          class: "mt-0"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.submitButtonText), 1)
          ], undefined, true),
          _: 1
        }, 8, ["rounded", "disabled"])
      ])
    ], 2)
  ]))
}